export default __webpack_public_path__ + "static/media/tomato.6b0e7dde.png";